
import rules from "@/services/helpers/validation-rules";
import DatePicker from "@/components/form-components/DatePicker.vue";
import Vue from "vue";

export default Vue.extend({
  name: "Absolvation",

  components: {
    DatePicker,
  },

  props: {
    value: {
      type: Object,
      required: true,
      default: () => ({}),
    },
    errorMessages: {
      type: Object,
      required: true,
      default: () => ({}),
    },
  },

  data: () => ({
    rules,
    valid: true,
    model: {} as any,
    selects: {
      universities: [] as Array<SelectComponentInterface>,
      studyPrograms: [] as Array<SelectComponentInterface>,
    },
    formsErrors: {
      absolvation: false,
    },
  }),

  watch: {
    value: {
      immediate: true,
      deep: true,
      handler() {
        this.model = this.value;
      },
    },
  },

  computed: {
    maxDiplom() {
      return this.$moment().format("YYYY-MM-DD");
    },
    publicationType() {
      return [
        {
          text: this.$t("applications.form.scientific_publications.article"),
          value: "article",
        },
        {
          text: this.$t("applications.form.scientific_publications.abstract"),
          value: "abstract",
        },
        {
          text: this.$t("applications.form.scientific_publications.poster"),
          value: "poster",
        },
      ];
    },
  },

  mounted() {
    this.loadData();
  },

  methods: {
    async loadData() {
      try {
        this.selects.studyPrograms = await this.$API.studyPrograms().getList();
        this.selects.universities = await this.$API.universities().getList();
      } catch (e) {
        await this.$store.dispatch("alert/showError", e.message);
      }
    },
    validate(key: string) {
      this.$nextTick(() => {
        this.$emit("validate", key);
      });
    },
    add(): void {
      this.model.scientific_publications.push({});
    },
    remove(index: number): void {
      this.model.scientific_publications.splice(index, 1);
    },
    onlyNumber(event: any) {
      let keyCode;
      if (event.keyCode) {
        keyCode = event.keyCode;
      } else {
        keyCode = event.which;
      }
      if ((keyCode < 48 || keyCode > 57) && keyCode !== 46) {
        event.preventDefault();
      }
    },
    isNumber(event: any): void {
      let theEvent = event || window.event;
      let key = theEvent.keyCode || theEvent.which;
      key = String.fromCharCode(key);
      if (key.length == 0) return;
      let regex = /^[0-9.,\b]+$/;
      if (!regex.test(key)) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
        return;
      }
      const input = theEvent.target as HTMLInputElement;
      const start = input.selectionStart ?? input.value.length;
      const end = input.selectionEnd ?? input.value.length;
      const newValue =
        input.value.slice(0, start) + key + input.value.slice(end);
      const isValidPartial = /^\d{1,2}([.,]\d{0,2})?$/.test(newValue);
      const numericValue = Number(newValue.replace(",", "."));
      if (
        !isValidPartial ||
        numericValue > 10 ||
        ((key === "." || key === ",") && Number(input.value) >= 10)
      ) {
        theEvent.returnValue = false;
        if (theEvent.preventDefault) theEvent.preventDefault();
      }
    },
    isNumberTest(event: any): void {
      this.isNumber(event);
    },
    isNumberTLicence(event: any): void {
      this.isNumber(event);
    },
    trimTrailingSeparator(field: string): void {
      const value = (this.model.graduated_university as any)[field];
      if (typeof value === "string" && /[.,]$/.test(value)) {
        (this.model.graduated_university as any)[field] = value.slice(
          0,
          -1
        );
      }
    },
    setObtainedTitle(event: number) {
      if (event === 1 || event === 3) {
        this.model.graduated_university.obtained_title = "medicine_licence";
      } else if (event === 2) {
        this.model.graduated_university.obtained_title = "dentistry_licence";
      } else if (event === 4) {
        this.model.graduated_university.obtained_title = "pharmacy_licence";
      }
    },
    setLabel(): any {
      if (!this.model.graduated_university.obtained_title) {
        return "";
      }
      return this.$t(
        `applications.form.graduated_university.degree.${this.model.graduated_university.obtained_title}`
      );
    },
    clearPublication(index: number): void {
      delete this.model.scientific_publications[index]?.id;
    },
  },
});
